import {ACTION_TYPE} from "utils/constants";

let newAssetCreated = false;
let isPublished = false;

export function _onInit() {
  this.ctx.addEventListener(ACTION_TYPE.OBJECT_ADDED, e => {
    if (this.missionIndex === 5) {
      newAssetCreated = true;
    }
  });
  this.ctx.addEventListener(ACTION_TYPE.CHANGE_PROGRESS, e => {
    if (this.missionIndex === 5 && e.detail.object === 100) {
      isPublished = true;
    }
  });
}

export function _onPlayStart() {
  let stepSuccess = false;
  const {script} = this.ctx.sceneEdit.userData;

  switch (this.missionIndex) {
    case 0:
      if (script?.includes("moveX(5)")) {
        stepSuccess = true;
      }
      break;
    case 1:
      if (script?.includes("moveX(20)")) {
        stepSuccess = true;
      }
      break;
    case 2:
      if (script?.includes("moveX(-20)")) {
        stepSuccess = true;
      }
      break;
    case 3:
      if (script?.includes("moveZ(30)")) {
        stepSuccess = true;
      }
      break;
    case 4:
      if (script?.includes("moveY(30)")) {
        stepSuccess = true;
      }
      break;
    case 5:
      if (script?.includes("moveX") && newAssetCreated && isPublished) {
        stepSuccess = true;
      }
      break;
    default:
      break;
  }
  setTimeout(() => {
    window.dispatchEvent(new CustomEvent(stepSuccess ? ACTION_TYPE.TUTORIAL_MISSION_SUCCESS : ACTION_TYPE.TUTORIAL_MISSION_FAIL));
  }, 5000);
}

export function _onPlayEnd() {}

export function _onPlaying() {}

export function _onReset() {
  newAssetCreated = false;
  isPublished = false;
}
